module.exports = __webpack_public_path__ + "img/icon4.5636305e.svg";